.section + .section {
  margin-top: var(--sp-7);
}

.legend {
  margin: 0 0 var(--sp-4);
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text-2);
}

/* ── Ползунок тем ───────────────────────────────────────────────────────────
   Видимая часть — полоски палитр и рамка над выбранной. Сам range лежит
   прозрачным слоем поверх: он нужен ради клавиатуры, роли и aria-valuetext. */
.slider {
  position: relative;
  height: 34px;
}

.bands {
  position: absolute;
  inset: 0;
  display: flex;
  overflow: hidden;
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius-lg);
}

.band {
  position: relative;
  flex: 1 1 0;
  min-width: 0;
}

/* Светлые палитры различаются только акцентом — без этой полоски первые
   четыре темы выглядели бы одним белым пятном. */
.bandAccent {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 7px;
}

.themeRange {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  appearance: none;
  background: none;
  opacity: 0;
  cursor: pointer;
}

.marker {
  position: absolute;
  top: -3px;
  bottom: -3px;
  width: 16px;
  transform: translateX(-50%);
  border: 2px solid var(--text);
  border-radius: var(--radius);
  box-shadow: 0 0 0 1px var(--surface);
  pointer-events: none;
  transition: left var(--dnd-dur) var(--dnd-ease);
}

/* Фокус живёт на прозрачном range, поэтому кольцо рисуем на рамке. */
.themeRange:focus-visible ~ .marker {
  box-shadow: var(--focus-ring);
}

/* ── Ползунок размера шрифта ────────────────────────────────────────────── */
.sizeRow {
  display: flex;
  align-items: center;
  gap: var(--sp-5);
}

/* Знаки по краям ползунка: слева «меньше», справа «больше». Общая коробка
   фиксированной ширины — иначе ползунки кегля и отступов встают вразнобой. */
.mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 22px;
  color: var(--text-3);
  font-weight: 700;
  line-height: 1;
}

.markSm {
  font-size: var(--fs-sm);
}

.markLg {
  font-size: var(--fs-xl);
}

/* Отступы показываем самими отступами: две рамки, тесная и просторная. */
.markSpaceSm,
.markSpaceLg {
  display: block;
  border: 2px solid currentColor;
  border-radius: 2px;
}

.markSpaceSm {
  width: 10px;
  height: 10px;
}

.markSpaceLg {
  width: 18px;
  height: 18px;
}

.sizeRange {
  flex: 1 1 auto;
  min-width: 0;
  height: 20px;
  margin: 0;
  appearance: none;
  background: none;
  cursor: pointer;
}

/* Дорожка и бегунок описываются отдельно для каждого движка: общего
   селектора у них нет, а любая опечатка в списке роняет всё правило. */
.sizeRange::-webkit-slider-runnable-track {
  box-sizing: border-box;
  height: 8px;
  background: var(--surface-sunken);
  border: var(--bw) solid var(--border);
  border-radius: 4px;
}

.sizeRange::-webkit-slider-thumb {
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  margin-top: -4px;
  appearance: none;
  background: var(--surface);
  border: 2px solid var(--text);
  border-radius: 50%;
  box-shadow: var(--shadow-card);
}

.sizeRange::-moz-range-track {
  box-sizing: border-box;
  height: 8px;
  background: var(--surface-sunken);
  border: var(--bw) solid var(--border);
  border-radius: 4px;
}

.sizeRange::-moz-range-thumb {
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  background: var(--surface);
  border: 2px solid var(--text);
  border-radius: 50%;
}

/* ── Подпись под ползунком ──────────────────────────────────────────────── */
.readout {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: var(--sp-4);
  margin-top: var(--sp-4);
}

.readoutName {
  font-size: var(--fs-lg);
  font-weight: 600;
}

.readoutMeta {
  color: var(--text-3);
  font-size: var(--fs-xs);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.note {
  margin-top: var(--sp-7);
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border);
  color: var(--text-3);
  font-size: var(--fs-xs);
  line-height: 1.5;
}

@media (prefers-reduced-motion: reduce) {
  .marker {
    transition: none;
  }
}
